import { IDishesContext, IFilterValues } from './dishesContext';

export enum DishesActionTypes {
	SET_DISHES = 'SET_DISHES',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	SET_ID_CATEGORY = 'SET_ID_CATEGORY',
	SET_ID_SUB_CATEGORY = 'SET_ID_SUB_CATEGORY',
	SET_PRICE_FROM = 'SET_PRICE_FROM',
	SET_PRICE_TO = 'SET_PRICE_TO',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	TOGGLE_UNASSIGNED_DISHES = 'TOGGLE_UNASSIGNED_DISHES',
	TOGGLE_DISABLED_DISHES = 'TOGGLE_DISABLED_DISHES',
	TOGGLE_SHOW_COMBO_ITEMS = 'TOGGLE_SHOW_COMBO_ITEMS',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_DISH_ID_FOR_DELETION = 'SET_DISH_ID_FOR_DELETION',
	SET_DISH_ID_FOR_FULL_INFO = 'SET_DISH_ID_FOR_FULL_INFO',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	CHANGE_FULL_DISH_INFO_VISIBLE_FORM = 'CHANGE_FULL_DISH_INFO_VISIBLE_FORM',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface ISetDishes {
	type: DishesActionTypes.SET_DISHES;
	payload: {
		dishes: IDishesContext['dishes'];
		typeOfModalWindow: IDishesContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: DishesActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IDishesContext['searchString'];
	};
}

interface ISetIDCustomer {
	type: DishesActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: IDishesContext['IDSelectedCustomer'];
	};
}

interface ISetIDRestaurant {
	type: DishesActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: IDishesContext['IDSelectedRestaurant'];
	};
}

interface ISetIDCategory {
	type: DishesActionTypes.SET_ID_CATEGORY;
	payload: {
		IDSelectedCategory: IDishesContext['IDSelectedCategory'];
	};
}

interface ISetIDSubCategory {
	type: DishesActionTypes.SET_ID_SUB_CATEGORY;
	payload: {
		IDSelectedSubCategory: IDishesContext['IDSelectedSubCategory'];
	};
}

interface ISetPriceFrom {
	type: DishesActionTypes.SET_PRICE_FROM;
	payload: {
		priceFrom: IDishesContext['priceFrom'];
	};
}

interface ISetPriceTo {
	type: DishesActionTypes.SET_PRICE_TO;
	payload: {
		priceTo: IDishesContext['priceTo'];
	};
}

interface IResetSelectedControls {
	type: DishesActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: DishesActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IDishesContext['sortBy'];
	};
}

interface IToggleUnassignedDishes {
	type: DishesActionTypes.TOGGLE_UNASSIGNED_DISHES;
}

interface IToggleDisabledDishes {
	type: DishesActionTypes.TOGGLE_DISABLED_DISHES;
}

interface IToggleShowComboItems {
	type: DishesActionTypes.TOGGLE_SHOW_COMBO_ITEMS;
}

interface ISetCountOfItems {
	type: DishesActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: IDishesContext['countOfItems'];
	};
}

interface ISetCurrentPage {
	type: DishesActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IDishesContext['currentPage'];
	};
}

interface ISetDishIDForDeletion {
	type: DishesActionTypes.SET_DISH_ID_FOR_DELETION;
	payload: {
		dishIDForDeletion: IDishesContext['dishIDForDeletion'];
		typeOfModalWindow: IDishesContext['typeOfModalWindow'];
	};
}

interface ISetDishIDForFullInfo {
	type: DishesActionTypes.SET_DISH_ID_FOR_FULL_INFO;
	payload: {
		dishIDForFullInfo: IDishesContext['dishIDForFullInfo'];
	};
}

interface IChangeTypeOfModalWindow {
	type: DishesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IDishesContext['typeOfModalWindow'];
	};
}

interface IChangeFullDishInfoVisibleForm {
	type: DishesActionTypes.CHANGE_FULL_DISH_INFO_VISIBLE_FORM;
	payload: {
		fullDishInfoVisibleForm: IDishesContext['fullDishInfoVisibleForm'];
	};
}

interface ISetFiltersFromQueryString {
	type: DishesActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TDishesActions =
	| ISetDishes
	| IChangeSearchString
	| ISetIDCustomer
	| ISetIDRestaurant
	| ISetIDCategory
	| ISetIDSubCategory
	| ISetPriceFrom
	| ISetPriceTo
	| IResetSelectedControls
	| ISetSortBy
	| IToggleUnassignedDishes
	| IToggleDisabledDishes
	| IToggleShowComboItems
	| ISetCountOfItems
	| ISetCurrentPage
	| ISetDishIDForDeletion
	| ISetDishIDForFullInfo
	| IChangeTypeOfModalWindow
	| IChangeFullDishInfoVisibleForm
	| ISetFiltersFromQueryString;
